export interface IOption {
  id: string
  name: string
}

export enum SearchState {
  NOT_STARTED = 'NOT_STARTED',
  SEARCHING = 'SEARCHING',
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED'
}
